<template>
  <section
    class="list-item-container"
    :class="{ 'view-only': viewOnly }"
    @click="goToProduct"
  >
    <section class="top-row">
      <span v-if="viewOnly && !product.volumeQuantity" class="quantity-readonly"
        >{{ product.quantity }} x</span
      >
      <!-- <div v-else class="selectbox-placeholder"></div> -->
      <span class="product-name"> {{ product.name }} </span>
    </section>
    <div class="product-specs">
      <quantity-input
        v-if="!viewOnly && !product.maxOrderAmount && !product.volumeQuantity"
        class="quantity"
        v-model="quantity"
        @update:val="$emit('set-qt', $event)"
      ></quantity-input>

      <div class="count-1" v-else-if="!viewOnly && product.maxOrderAmount">
        {{ product.quantity }} x
      </div>

      <div class="count-1" v-else-if="product.volumeQuantity">
        {{ product.volumeQuantity }} x
      </div>

      <package-image
        v-if="product.type === 'package'"
        :product="product"
      ></package-image>

      <product-thumbnail
        :class="{ pointer: !viewOnly }"
        v-else
        :product="product"
      ></product-thumbnail>

      <section class="specs-holder">
        <spec v-if="product.type === 'package'" class="title"
          >Kant-en-klaar pakket</spec
        >
        <spec v-else-if="product.product" class="title">{{
          $filters.capitalize(product.product)
        }}</spec>

        <spec v-for="(spec, name) in printSpecification" :key="name">
          <span v-if="name !== 'info'"
            ><span class="title">{{ name }}: </span>{{ spec }}</span
          >
        </spec>

        <spec v-for="(image, index) in product.customImages" :key="index">
          <span class="title">{{ image.title }}: </span>
          <span v-for="(img, i) in image.images" :key="i">
            {{ img.name }}<span v-if="i < image.images.length - 1">, </span>
          </span>
        </spec>

        <spec v-if="product.price && !hidePricing">
          <span class="title" v-if="product.volumeQuantity">Prijs: </span
          ><span class="title" v-else>Prijs p.st. </span>€{{ product.price }}
        </spec>
      </section>
      <button
        v-if="!viewOnly"
        class="remove-file"
        @click.stop="$emit('remove', product)"
      >
        <svg class="trash" width="15px" height="15px" viewBox="0 0 15 15">
          <title>prullenmand</title>
          <g id="prullenmand">
            <path
              fill="#4f4f4f"
              d="M3,4 L3,13.25 C3,13.6642136 3.3581722,14 3.8,14 L10.2,14 C10.6418278,14 11,13.6642136 11,13.25 L11,4 L3,4 Z M9,2 L13,2 L13,3 L12,3 L12,13.4285714 C12,14.2964475 11.2538079,15 10.3333333,15 L3.66666667,15 C2.74619208,15 2,14.2964475 2,13.4285714 L2,3 L1,3 L1,2 L5,2 L5,1 C5,0.44771525 5.44771525,1.01453063e-16 6,0 L8,0 C8.55228475,-1.01453063e-16 9,0.44771525 9,1 L9,2 Z M5,6 L5,12 L6,12 L6,6 L5,6 Z M8,6 L8,12 L9,12 L9,6 L8,6 Z"
            ></path>
          </g>
        </svg>
      </button>
    </div>
  </section>
</template>

<script>
import { mapStores } from 'pinia'
import { usePrintStoreStore } from '@/features/printstore/PrintStore.store'
import QuantityInput from '../../../../components/ui/QuantityInput.vue'
import Spec from '../listitem/Spec.vue'
import PackageImage from './PackageImage.vue'
import ProductThumbnail from '../../../../features/printOrder/children/printstore/ProductThumbnail'
import PrintStoreMixin from '../../../../features/printstore/PrintStoreMixin'

export default {
  components: { QuantityInput, Spec, ProductThumbnail, PackageImage },
  props: {
    product: {
      type: Object
    },
    viewOnly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  mixins: [PrintStoreMixin],
  computed: {
    ...mapStores(usePrintStoreStore),
    printSpecification() {
      let specs = { ...this.product.printSpecification }
      delete specs['info']
      return specs
    },
    hidePricing() {
      if (this.hidePrice) {
        return true
      } else if (
        this.hideOwnPrice &&
        this.product.printStoreId != this.printStoreStore.defaultPrintStoreId
      ) {
        return true
      } else {
        return false
      }
    },
    quantity: {
      get() {
        return this.product.quantity
      },
      set(value) {
        this.$emit('set-qt', value)
      }
    }
  },
  methods: {
    goToProduct() {
      if (this.viewOnly) {
        return
      }
      if (this.product.type === 'package') {
        this.$router.push({
          name: 'printStorePackage',
          params: {
            categoryId: this.product.categoryId,
            packageId: this.product.id
          }
        })
      } else {
        const queryObject = {}

        if (this.product.printSpecification) {
          queryObject.currentSpecs = JSON.stringify(
            this.product.printSpecification
          )
        }

        if (this.product.isCustomizable && this.product.customFields) {
          queryObject.customFields = JSON.stringify(this.product.customFields)
        }

        this.$router.push({
          name: 'printStoreProduct',
          params: {
            categoryId: this.product.categoryId,
            collectionId: this.product.collectionId,
            productId: this.product.id
          },
          query: queryObject
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@use '../../../../sass/helpers/_variables.scss' as *;
@use '../../../../sass/base/_colors.scss' as *;

.list-item-container {
  padding: 15px;
  border-radius: 35px;
  transition: 0.5s all;

  &:hover {
    cursor: pointer;
    background-color: $list-hover;
  }

  &.view-only:hover {
    background-color: white;
    cursor: unset;
  }
}

.top-row {
  display: flex;
  align-items: flex-start;
}

.selectbox-placeholder {
  width: 23px;
}

.quantity-readonly {
  padding-right: 5px;
}

.product-name {
  font-weight: 600;
  flex-grow: 1;
}
.product-specs {
  display: flex;
  padding-top: 12px;
}

.quantity {
  margin-right: 12px;
  flex-shrink: 0;
  flex-grow: 0;
}

.title {
  font-weight: 500;
}

.specs-holder {
  flex-grow: 1;
  //margin-bottom: -7px;
  padding-top: 9px;
}

.remove-file {
  margin-top: auto;
  padding-bottom: 7px;
  padding-right: 1px;
}

.trash {
  width: 21px;
  height: 21px;
  padding: 3px;

  &:hover {
    path {
      transition: fill 0.4s;
      fill: $rijnja-red;
    }
  }
}

.count-1 {
  line-height: 39px;
  padding: 0 23px 0 11px;
}
</style>
